export default __webpack_public_path__ + "static/media/adetokunbo-ige.195e0bad.png";